import { render, staticRenderFns } from "./processManagement.vue?vue&type=template&id=18a3463e&scoped=true&"
import script from "./processManagement.vue?vue&type=script&lang=js&"
export * from "./processManagement.vue?vue&type=script&lang=js&"
import style0 from "./processManagement.vue?vue&type=style&index=0&id=18a3463e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a3463e",
  null
  
)

export default component.exports